<template>
  <div class="buttons is-centered">
    <b-button
      tag="router-link"
      :to="getPath()"
      type="is-info"
      expanded
      :loading="loading"
    >
      {{ startButtonText }}
    </b-button>
  </div>
</template>

<script>
import routeMixin from "@/mixins/routeMixin";
import authMixin from "@/mixins/authMixin";

export default {
  props: ["bookId", "lastSection", "lastPracticeMode", "loading"],
  mixins: [routeMixin, authMixin],
  computed: {
    nextSectionNumber() {
      return this.lastSection === 0 ? 1 : this.lastSection;
    },
    startButtonText() {
      if (this.lastSection === 0) return "Start reading";
      return `Continue from ${this.nextSectionNumber}`;
    }
  },
  methods: {
    getPath() {
      return this.getSectionPath(
        this.bookId,
        this.nextSectionNumber,
        this.lastPracticeMode
      );
    }
  }
};
</script>

<style lang="scss" scoped></style>
